// contact-form-validation.js
(function () {
  // Attach to all contact forms created by your section (ids end with "-contact")
  var forms = Array.prototype.slice.call(document.querySelectorAll('form[id$="-contact"]'));
  if (!forms.length) return;
  forms.forEach(attachValidation);

  function attachValidation(form) {
    form.setAttribute('novalidate', 'novalidate');

    // Collect visible, named fields in the "contact[...]" namespace
    var fields = Array.prototype.slice.call(
      form.querySelectorAll('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]')
    ).filter(function (el) {
      if (!el.name) return false;
      if (el.type === 'hidden') return false;
      // Ignore the hidden mirror that precedes required checkboxes
      if (el.type === 'checkbox' && el.previousElementSibling && el.previousElementSibling.type === 'hidden' &&
          el.previousElementSibling.name === el.name) {
        return true; // keep the real checkbox
      }
      return true;
    });

    if (!fields.length) return;

    var summary = ensureSummary(form);
    var summaryList = summary.querySelector('[data-error-list]');

    // Live validation
    fields.forEach(function (el) {
      el.addEventListener('blur', function () { validateAndRenderField(el, form); });
      el.addEventListener('input', function () { clearSummary(summary, summaryList); debounce(el, function(){ validateAndRenderField(el, form); }); });
      el.addEventListener('change', function () { validateAndRenderField(el, form); });
    });

    // Submit
    form.addEventListener('submit', function (e) {
      clearSummary(summary, summaryList);
      var errors = {};
      fields.forEach(function (el) {
        var msg = validateField(el);
        setFieldError(el, msg, form);
        if (msg) errors[el.name] = msg;
      });

      if (Object.keys(errors).length) {
        e.preventDefault();
        renderSummary(errors, form, summary, summaryList);
        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus({ preventScroll: false });
      }
    });
  }

  /* -------------------- Validation logic -------------------- */

  function validateAndRenderField(el, form) {
    var msg = validateField(el);
    setFieldError(el, msg, form);
    return msg;
  }

  function validateField(el) {
    var val = (el.value || '').trim();
    var required = !!el.required || el.getAttribute('aria-required') === 'true';

    // Checkbox presence
    if (el.type === 'checkbox') {
      if (required && !el.checked) return composeMsg(el, 'is required');
      return '';
    }

    // Presence
    if (required && !val) {
      return composeMsg(el, 'is required');
    }
    if (!val) return ''; // optional & empty => OK

    // Pattern attribute (developer-specified) takes priority
    var pattern = el.getAttribute('pattern');
    if (pattern) {
      var re = new RegExp(pattern);
      if (!re.test(val)) return composeMsg(el, 'is not in the correct format');
    }

    // Type-specific
    var type = (el.getAttribute('type') || el.tagName.toLowerCase()).toLowerCase();

    // Email
    if (type === 'email' || /\[email\]/i.test(el.name)) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) return 'Please enter a valid email address';
      return '';
    }

    // Phone (tolerant: digits, spaces, (), +, -, .) min 7 meaningful chars
    if (type === 'tel' || /\b(phone|tel|telephone|mobile)\b/i.test(el.name)) {
      if (!/^[0-9+()\-.\s]{7,}$/.test(val)) return 'Please enter a valid phone number';
      return '';
    }

    // UK Postcode (heuristic: field name contains "postcode" or "post code")
    if (/\b(post\s*code|postcode)\b/i.test(el.name) || /postcode/i.test(getLabelText(el))) {
      var pcOK = /^(?:GIR 0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/i.test(val);
      if (!pcOK) return 'Please enter a valid UK postcode';
      return '';
    }

    // URL
    if (type === 'url' || /\b(url|website|link)\b/i.test(el.name)) {
      try { new URL(val.indexOf('://') === -1 ? 'https://' + val : val); }
      catch (e) { return 'Please enter a valid URL'; }
      return '';
    }

    // Number
    if (type === 'number') {
      if (!/^-?\d+(?:[.,]\d+)?$/.test(val)) return 'Please enter a valid number';
      return '';
    }

    // Textarea/content can have a min length if desired; skip for generic case
    return '';
  }

  /* -------------------- UI helpers -------------------- */

  function ensureSummary(form) {
    var summary = form.querySelector('[data-error-summary]');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'alert mt-6 bg-error-bg text-error-text';
      summary.setAttribute('role', 'alert');
      summary.setAttribute('data-error-summary', 'true');
      summary.hidden = true;
      summary.innerHTML =
        '<h2 class="h5 text-current">There was a problem with your submission:</h2>' +
        '<ul class="styled-list" data-error-list></ul>';
      form.appendChild(summary);
    }
    return summary;
  }

  function clearSummary(summary, list) {
    summary.hidden = true;
    if (list) list.innerHTML = '';
  }

  function renderSummary(errorsByName, form, summary, list) {
    clearSummary(summary, list);
    Object.keys(errorsByName).forEach(function (name) {
      var field = form.querySelector('[name="' + cssEscape(name) + '"]');
      var label = getLabelText(field);
      var text = (label ? (label + ': ') : '') + errorsByName[name];
      var li = document.createElement('li');
      if (field && field.id) {
        var a = document.createElement('a');
        a.href = '#' + field.id;
        a.className = 'link text-current';
        a.textContent = text;
        li.appendChild(a);
      } else {
        li.textContent = text;
      }
      list.appendChild(li);
    });
    summary.hidden = false;
  }

  function setFieldError(el, message, form) {
    var p = ensureInlineErrorEl(el, form);
    if (message) {
      el.setAttribute('aria-invalid', 'true');
      if (p.id) el.setAttribute('aria-describedby', p.id);
      p.textContent = message;
      p.hidden = false;
      el.classList.remove('is-valid');
      el.classList.add('is-invalid');
    } else {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-describedby');
      p.textContent = '';
      p.hidden = true;
      if ((el.type === 'checkbox' && el.checked) || (el.value && el.value.trim())) {
        el.classList.add('is-valid');
        el.classList.remove('is-invalid');
      } else {
        el.classList.remove('is-valid', 'is-invalid');
      }
    }
  }

  function ensureInlineErrorEl(el, form) {
    var id = (el.id || el.name) + '-error';
    var p = form.querySelector('#' + cssEscape(id));
    if (!p) {
      p = document.createElement('p');
      p.className = 'form__field-error';
      p.id = id;
      p.hidden = true;
      // For checkboxes, place error after the label; otherwise after the field
      if (el.type === 'checkbox') {
        var label = form.querySelector('label[for="' + cssEscape(el.id) + '"]');
        (label || el).insertAdjacentElement('afterend', p);
      } else {
        el.insertAdjacentElement('afterend', p);
      }
    }
    return p;
  }

  function getLabelText(el) {
    if (!el) return '';
    var label = el.id && el.form ? el.form.querySelector('label[for="' + cssEscape(el.id) + '"]') : null;
    if (label) return label.textContent.replace(/\*/g, '').trim();
    // Fallback to a tidy version of the name
    return String(el.name || '').replace(/^contact\[|\]$/g, '').replace(/_/g, ' ');
  }

  // Simple message composer: "Email is required", "Phone is not in the correct format", etc.
  function composeMsg(el, tail) {
    var label = getLabelText(el);
    return (label ? label : 'This field') + ' ' + tail;
  }

  /* -------------------- utilities -------------------- */

  var debouncers = new WeakMap();
  function debounce(el, fn, delay) {
    delay = delay || 200;
    var prev = debouncers.get(el);
    if (prev) clearTimeout(prev);
    var t = setTimeout(fn, delay);
    debouncers.set(el, t);
  }

  // Minimal CSS.escape for ids/names we generate
  function cssEscape(str) {
    return String(str).replace(/(["\\])/g, '\\$1');
  }
})();
